"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageWizardPanel = void 0;
const react_1 = __importStar(require("react"));
const PageWizardPanelContext_1 = require("../context/PageWizardPanelContext");
const SidePanel_1 = require("../../SidePanel");
/**
 * @deprecated Use Modal with MODAL_VIEW.sidePanel
 */
function usePageWizardPanel({ title, description, shrink, minWidth, width, canClose, onClose, render }) {
    const panelApi = (0, react_1.useContext)(PageWizardPanelContext_1.PageWizardPanelContext);
    const deactivate = (0, react_1.useCallback)(() => {
        panelApi.deactivate();
    }, [panelApi]);
    const activate = (config) => {
        const content = render({ deactivate, data: config === null || config === void 0 ? void 0 : config.data });
        if (!content) {
            return;
        }
        panelApi.activate(react_1.default.createElement(SidePanel_1.SidePanel, {
            title: (config === null || config === void 0 ? void 0 : config.title) || title,
            description: (config === null || config === void 0 ? void 0 : config.description) || description,
            canClose,
            onRequestClose: () => {
                deactivate();
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        }, content), { isShrink: shrink, minWidth, width });
    };
    return {
        activate,
        deactivate,
        isShown: !!panelApi.element
    };
}
exports.usePageWizardPanel = usePageWizardPanel;
//# sourceMappingURL=usePageWizardPanel.js.map